// @ts-nocheck
import React from "react";
import { Box } from "theme-ui";
import JsxParser from 'react-jsx-parser'
import { UnityPlayer } from './unity-player';

const styles = {
    fontFamily: "sans-serif",
    textAlign: "center",
  };

export const SideScroller = ( {childData, properties} ) => {

    const styleLeft={
        outline: "1px solid",
        left: properties.width / 16,
        position:"fixed", 
        float: "left", 
        width: properties.width, 
        height: properties.height, 
        alignItems: "center", 
        justifyContent:"center" }

    const styleRight = {
        outline: "1px solid",
        right: properties.width / 16,
        position:"fixed", 
        float: "right", 
        height: properties.height, 
        alignItems: "center", 
        justifyContent:"center" }

    return (
        <Box style={styles}>
            <Box style={properties.alignedTo === "left" ? styleLeft : styleRight}>
                <JsxParser
                    bindings={{ }}
                    components={{ UnityPlayer }}
                    jsx= {childData}
                />
            </Box>
        </Box>
    
        );
};
